import { render, staticRenderFns } from "./LanguageDropdown.vue?vue&type=template&id=6f2e75de&scoped=true"
import script from "./LanguageDropdown.vue?vue&type=script&lang=ts"
export * from "./LanguageDropdown.vue?vue&type=script&lang=ts"
import style0 from "./LanguageDropdown.vue?vue&type=style&index=0&id=6f2e75de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2e75de",
  null
  
)

export default component.exports